import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

const pinIcon = L.divIcon({
  className: "",
  html: '<div style="width:24px;height:24px;background:#FF3B30;border:2px solid #0a0a0a;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,0.6)"></div>',
  iconSize: [24, 24],
  iconAnchor: [12, 24],
});

export function BrowseMap({ items }) {
  const withCoords = items.filter((i) => typeof i.lat === "number" && typeof i.lng === "number");
  const mapCenter = withCoords.length ? [withCoords[0].lat, withCoords[0].lng] : [40.7128, -74.006];
  return (
    <div className="mt-10 border hairline" data-testid="kitchen-map">
      <div className="h-[620px]">
        <MapContainer center={mapCenter} zoom={12} scrollWheelZoom style={{ height: "100%", width: "100%", background: "#0a0a0a" }}>
          <TileLayer
            attribution='&copy; OpenStreetMap'
            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png"
          />
          {withCoords.map((k) => (
            <Marker key={k.id} position={[k.lat, k.lng]} icon={pinIcon}>
              <Popup>
                <div style={{ minWidth: 180 }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{k.name}</div>
                  <div style={{ color: "#555", fontSize: 12 }}>{k.city}</div>
                  <div style={{ marginTop: 6, fontFamily: "monospace" }}>${k.hourly_rate}/hr</div>
                  <Link to={`/kitchen/${k.id}`} style={{ color: "#FF3B30", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.2em" }}>View →</Link>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      {withCoords.length < items.length && (
        <div className="tick-label p-3 border-t hairline">{items.length - withCoords.length} kitchen(s) hidden — no coordinates yet</div>
      )}
    </div>
  );
}
